import { IApplication } from "shared/model/IApplication";

import RavenService from "../../../services/Logging/RavenService";
import ApplicationUtils from "../../../services/utils/ApplicationUtils";

export interface ILandbotProps {
  email?: string;
  id?: string;
  first_name?: string;
  cowork_name?: string;
  name?: string;
  status?: string;
  status_display?: string;
  deposit_amount?: string;
  payment_amount?: string;
}

export const createLandbotProps = (
  applicationId: string,
  application?: IApplication,
  coworkName?: string
) => {
  if (!applicationId) {
    const errorMessage = `Can't create landbot props with no app id.`;
    console.error(errorMessage);
    RavenService.captureMessage(errorMessage);
  }

  const props: ILandbotProps = { id: applicationId };
  if (application) {
    const {
      applicantEmail,
      status,
      amount,
      monthlyPaymentAmount
    } = application;

    const nameParts = ApplicationUtils.applicantNameParts(application);
    if (nameParts) {
      props.first_name = nameParts.first;
      props.name = nameParts.full;
    }

    if (applicantEmail) {
      props.email = applicantEmail;
    }

    if (coworkName) {
      props.cowork_name = coworkName;
    }

    if (status) {
      props.status = status;
      props.status_display = ApplicationUtils.applicationStatusName(status);
    }

    if (amount) {
      props.deposit_amount = amount.toString();
    }

    if (monthlyPaymentAmount) {
      props.payment_amount = monthlyPaymentAmount.toString();
    }
  }

  return props;
};



// WEBPACK FOOTER //
// ./src/state/modules/membersChat/MemberChatLandbotProps.ts